<template>
  <div class="home">
    <!-- 顶部 -->
    <Tab :kexs="2"></Tab>
    <!-- body -->
    <div class="body">
      <!-- 拍品列表 -->
      <div class="AuctionList">
        <div class="AuctionList-left">
          <img :src="data.image_text"  @error="errorImg" alt="" />
          <!-- type 0:顺序排  1：网络拍 -->
          <div v-if="data.type == 0" class="AuctionList-left-state">顺序拍</div>
          <div
            v-if="data.type == 1"
            class="AuctionList-left-state AuctionList-left-states"
          >
            网络拍
          </div>
        </div>
        <div class="AuctionList-right">
          <div class="AuctionList-right-time">
            {{ data.start_time_text.substring(0,6)}}
            <span style="color: #c7171e">
              {{ data.start_time_text.substring(6,12)}}开始</span
            >
          </div>
          <div class="AuctionList-right-title">
            {{data.title}}
          </div>
          <div class="AuctionList-right-name">
            拍卖企业：{{data.userrealinfor.enterprisename}}
          </div>
          <div
            style="display: flex; font-size: 12px; color: #666; margin-top: 8px"
          >
            <div style="display: flex; align-items: center; margin-right: 32px">
              <div style="width: 10px; height: 10px; margin-right: 4px">
                <img src="../../assets/image/renshu.png" alt="" />
              </div>
              <div>{{data.onlookers}}人围观</div>
            </div>
            <div style="display: flex; align-items: center">
              <div style="width: 10px; height: 10px; margin-right: 4px">
                <img src="../../assets/image/biaodi.png" alt="" />
              </div>
              <div>{{data.objectmanagement.length}}标的</div>
            </div>
          </div>
          <div class="AuctionList-right-money"  v-if="data.objectmanagement.length != 0">
            当前价：<span style="font-size: 20px; color: #c7171e">{{data.objectmanagement[0].current_price}}</span>
          </div>
          <div class="AuctionList-right-box">
            <div class="AuctionList-right-box1 AuctionList-right-boxs">
              标的目录
            </div>
            <div class="AuctionList-right-box2 AuctionList-right-boxs pointer" @click="handleJp('Details',data.objectmanagement[0].id,data.id)">
              竞拍大厅
            </div>
          </div>
        </div>
      </div>
      <div v-if="data.objectmanagement">
        <div class="list">标的列表</div>
        <!-- 拍品列表 -->
        <div class="Lots">
          <div
            class="Lots-box"
            v-for="(item, index) in data.objectmanagement"
            :key="'lot-' + index"
            @click="page('Details',item.id)"
          >
            <div class="Lots-img">
              <img :src="item.images_text[0]" @error="errorImg" alt="" />
              <!-- status  0:未发布 1：已发布  2：正在进行 3.即将开始  4.已暂停  5.已成交  6.未成交  7.已撤回 -->
              <div class="Lots-text" v-if="item.status == 2">正在进行</div>
              <div class="Lots-text Lots-text1" v-else-if="item.status == 3">
                即将开始
              </div>
              <div class="Lots-text Lots-text2" v-else-if="item.status == 5">
                已成交
              </div>
              <div class="Lots-text Lots-text3" v-else>
                {{item.status_text}}
              </div>
            </div>
            <div style="position: relative">
              <div class="Lots-name">{{item.title}}</div>
              <div class="Lots-money">
                当前价：<span class="Lots-moneys">{{item.current_price}}元</span>
              </div>
              <div class="Lots-time">开始时间：{{item.start_time_text}}</div>
              <div class="weiguan">
                <div style="width: 10px; height: 10px; margin-right: 4px">
                  <img src="../../assets/image/renshu.png" alt="" />
                </div>
                <div>{{item.onlookers}}人围观</div>
              </div>
              <!-- biddingmode 0.增价 1.减价 -->
              <div v-if="item.biddingmode == 1" class="AuctionList-right-text">
                减价
              </div>
              <div
                v-else-if="item.biddingmode == 0"
                class="AuctionList-right-text AuctionList-right-text1"
              >
                增价
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 公告 -->
      <div class="Notice" v-html="data.notice.content">
        <div class="Notice-h">{{data.notice.title}}</div>
        <div>
         {{data.notice.content}}
        </div>
        <div class="Notice-text">
          <div class="ge"></div>
          <div>展示时间：{{data.notice.preview_time_text}}</div>
        </div>
        <div class="Notice-text">
          <div class="ge"></div>
          <div>展示地点：标的所在地</div>
        </div>
        <div class="Notice-text">
          <div class="ge"></div>
          <div>咨询电话：0335</div>
        </div>
        <div class="Notice-text">
          <div class="ge"></div>
          <div>公司地址：秦皇岛市海港区河北大街西段61号如意山海酒店2楼</div>
        </div>
        <div style="margin-top: 8px">
          注明：本次拍卖会采取网络竞价的方式。有意竞买者交付保证金办理竞买手续，并按要求办理其他相关事宜。以支票或汇票形式交付保证金的，须全部款项
          入账后方可办理。 河北如意山海拍卖有限公司
        </div>
      </div>
      <!-- 保障 -->
      <Guarantee></Guarantee>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Tab from "@/components/tab.vue";
import Footer from "@/components/footer.vue";
import Guarantee from "@/components/Guarantee.vue";
export default {
  name: "Home",
  data() {
    return {
      data: {
        start_time_text:'',
        userrealinfor:{
          enterprisename:'',
        },
        objectmanagement:[{
          current_price:0,
          images_text:[]
        }],
        notice:{
          content:'',
        }
      },
    };
  },
  mounted() {
    // 拍卖会详情
    this.$apis
      .Attractdetail({
        id: this.$route.query.id,
        is_admin:this.$route.query.is_admin
      })
      .then((res) => {
        this.data = res.data;
      });
  },

  components: {
    Tab,
    Footer,
    Guarantee,
  },
  created() {
    window.scrollTo(0, 0);
  },
  methods: {
    errorImg(event) {
      this.$pk.errorImg(event);
    },
    page(e,id) {
      this.$router.push({
        name: e,
        query: {
          id: id,
          auction_id:this.$route.query.id
        },
      });
    },
    // 跳标的详情
    handleJp(e,id,auction_id){
      this.$router.push({
        name: e,
        query: {
          id: id,
          auction_id:auction_id
        },
      });
    }
  },
};
</script>
<style scoped='scoped'>
img {
  width: 100%;
  height: 100%;
}
i {
  font-size: 18px;
}
.home {
  overflow-x: hidden;
  background-color: #f5f5f5;
}
.body {
  width: 1136px;
  margin: 0 auto;
  padding: 16px 0 0;
}
.tz {
  width: 69px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #ffffff;
  font-size: 14px;
  color: #999;
  border-radius: 4px;
  border: 1px solid #c0c4cf;
}
/* 拍品列表 */
.AuctionList {
  display: flex;
  margin: 16px 0;
}
.AuctionList-left {
  position: relative;
  width: 58%;
  height: 270px;
}
.AuctionList-right {
  width: 42%;
  background-color: #fff;
  /* height: 270px; */
  position: relative;
  padding: 12px 5%;
}
.AuctionList-right-text {
  width: 80px;
  height: 29px;
  background: #18a2d6;
  opacity: 1;
  border-radius: 15px 0px 0px 15px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 29px;
  position: absolute;
  top: 8px;
  right: 0;
}
.AuctionList-right-text1 {
  background-color: #e95000;
}
.AuctionList-right-time {
  font-size: 14px;
  color: #333;
}
.AuctionList-right-title {
  font-size: 18px;
  font-weight: 400;
  margin-top: 16px;
}
.AuctionList-right-name {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}
.AuctionList-right-money {
  font-size: 14px;
  color: #333;
  margin-top: 20px;
}
.AuctionList-right-box {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
}
.AuctionList-right-box1 {
  background: #c7171e;
  color: #fff;
}
.AuctionList-right-box2 {
  border: 1px solid #c7171e;
  color: #c7171e;
}
.AuctionList-right-boxs {
  width: 144px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  font-size: 14px;
}
.AuctionList-left-state {
  width: 88px;
  height: 27px;
  line-height: 27px;
  text-align: center;
  background: #c7171e;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  font-size: 14px;
}
.AuctionList-left-states {
  background-color: #18a2d6;
}

/*  */
.Lots {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}
.Lots-box {
  background-color: #fff;
  width: 24.1%;
  margin-bottom: 24px;
  margin-right: 1.2%;
}
.Lots-img {
  width: 100%;
  height: 196px;
  position: relative;
}
.Lots-text {
  padding: 4px 16px;
  font-size: 14px;
  color: #fff;
  background-color: #c7171e;
  position: absolute;
  top: 0;
  right: 0;
}
.Lots-text1 {
  background-color: #18a2d6;
}
.Lots-text2 {
  background-color: #3bd38e;
}
.Lots-text3 {
  background-color: #999999;
}
.Lots-name {
  font-size: 18px;
  padding: 14px 0px 10px 16px;
}
.Lots-money {
  font-size: 14px;
  color: #666;
  padding-left: 16px;
}
.Lots-moneys {
  color: #c7171e;
  font-size: 20px;
}
.Lots-time {
  font-size: 14px;
  color: #666;
  padding: 12px 0 8px 16px;
}
.list {
  font-size: 20px;
  font-weight: Bold;
  margin: 24px 0;
}
.weiguan {
  display: flex;
  align-items: center;
  margin-right: 32px;
  font-size: 12px;
  color: #666;
  padding: 0 0 24px 16px;
}
.Notice {
  width: 100%;
  padding: 24px;
  background-color: #fff;
  margin-bottom: 56px;
  font-size: 16px;
  color: #666;
}
.Notice-h {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  margin-bottom: 24px;
}
.ge {
  width: 4px;
  height: 18px;
  background: #c7171e;
  opacity: 1;
  border-radius: 2px;
  margin-right: 8px;
}
.Notice-text {
  display: flex;
  align-items: center;
  margin-top: 17px;
}
@media only screen and (min-width: 991px) {
  .Lots-box:nth-child(4n) {
    margin-right: 0;
  }
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
  /* 拍品列表 */
  .AuctionList-right-title {
    font-size: 15px;
  }
  .AuctionList-right-money {
    margin-top: 8px;
  }
  .AuctionList-right-text {
    width: 59px;
    height: 25px;
    line-height: 25px;
  }
  .Lots-box {
    width: 30.7%;
    margin-right: 3.8%;
  }

  .Lots-box:nth-child(3n) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .body {
    width: 98%;
    margin: 0 auto;
    padding: 10px 0 0;
  }
  i {
    font-size: 14px;
  }
  /* 拍品列表 */
  .AuctionList {
    flex-direction: column;
    width: 95%;
    margin: 10px auto;
  }
  .AuctionList-left {
    width: 100%;
  }
  .AuctionList-right {
    width: 100%;
    padding: 11px 10px;
  }
  /* .Lots-img {
    height: 135px;
  } */
  .Lots-box {
    width: 49.1%;
    margin-right: 1.8%;
  }
  .Lots-box:nth-child(2n) {
    margin-right: 0;
  }
  .AuctionList-right-text {
    width: 50px;
    height: 22px;
    line-height: 22px;
  }
  .Lots-name {
    font-size: 16px;
    padding: 10px 0px 10px 5px;
  }
  .Lots-money {
    padding-left: 5px;
  }
  .Lots-moneys {
    font-size: 18px;
  }
  .Lots-time {
    padding: 7px 0 0 5px;
  }
  .list {
    text-align: center;
  }
  .weiguan {
    padding: 7px 0 20px 5px;
  }
  .Notice {
    padding: 10px;
    margin-bottom: 30px;
  }
}
</style>
